import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'transportDocumentType',
})
export class TransportDocumentTypePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(documentType: string | null | undefined): string | undefined {
    if (!documentType) {
      return undefined;
    }

    const prefix = 'pages.transport.upload-dialog.file-types';
    const key = `${prefix}.${documentType}`;

    const translation = this.translateService.instant(key);
    if (translation == key) {
      // translation was not found - just return the abbreviation.
      return documentType;
    }

    return translation;
  }
}
